import { Box, IconButton, Modal, styled, Typography } from '@mui/material';
import { FEEDBACK_MODAL_Z_INDEX } from 'style/constants';

export const StyledModal = styled(Modal)({
  width: 'fit-content',
  maxWidth: '610px',
  minHeight: 'fit-content',
  maxHeight: '300px',
  margin: 'auto',
  outline: 'none',
  zIndex: FEEDBACK_MODAL_Z_INDEX,
  '& .MuiModal-backdrop': {
    backdropFilter: 'blur(2px)',
  },
});

export const ContentWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  boxShadow: `0px 4px 14px ${theme.palette.primary.main}`,
  borderRadius: '5px',
  padding: theme.spacing(2, 12, 8, 12),
  outline: 'none',
}));

export const IconWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  '> svg': {
    height: '45px',
    width: '45px',
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(6),
  color: theme.palette.primary.main,
}));

export const StyledMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  whiteSpace: 'pre-wrap',
  maxHeight: '100px',
  overflowY: 'auto',
  overflowX: 'hidden',
}));

interface IButtonsWrapper {
  oneBtnOnly: boolean;
}

export const ButtonsWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'oneBtnOnly',
})<IButtonsWrapper>(({ oneBtnOnly, theme }) => ({
  marginTop: theme.spacing(6),
  display: 'flex',
  justifyContent: oneBtnOnly ? 'center' : 'space-between',
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  position: 'absolute',
  top: '10px',
  right: '10px',
}));
